import Settings from "./page";
import Profile from "./sections/profile/page";
import Account from "./sections/account/page";
import Security from "./sections/security/page";
import Organizations from "./sections/organizations/page";
import Applications from "./sections/applications/page";
import { Navigate } from "react-router-dom";

const settingRoutes = [
    {
        path: "settings",
        element: <Settings />,
        children: [
            { index: true, element: <Navigate to="profile"/> },
            { path: "profile", element: <Profile /> },
            { path: "account", element: <Account /> },
            { path: "security", element: <Security /> },
            { path: "organizations", element: <Organizations /> },
            { path: "applications", element: <Applications /> }
        ],
    },
];

export default settingRoutes;
